export const parseApiForgotPasswordError = (errorType?: string) => {
  if (errorType === 'USER_DOESNT_EXISTS') {
    return 'This email has no account';
  }

  return "Can't reset password, please retry.";
};
